/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import style from "../styles/privacy.module.scss";
import { GlobalContext } from "../context/GlobalContext";
import ReactMarkdown from "react-markdown";
import Loader from "../components/shared/Loader";
import withHelmet from "../seo/withHelmet";
import { shippingHelmetProps } from "../seo/helmetProps";

const Shipping = () => {
  const { loading, getShipping, shipping } = useContext(GlobalContext);

  useEffect(() => {
    getShipping();
  }, []);
  return (
    <>
      {loading || shipping === undefined ? (
        <Loader />
      ) : (
        <div className={style.wrapper}>
          <ReactMarkdown>{shipping}</ReactMarkdown>
        </div>
      )}
    </>
  );
};

export default withHelmet(Shipping, shippingHelmetProps);
